
// Utilities file 

export const isNZ: boolean = location.hostname.includes('.nz');
export const shopUrl: string | undefined = window?.Shopify?.shop;
export const isMobile: boolean = window.innerWidth < 700;
